// Wrapper around our Typography Placeholder
import withTypography from './withTypography'
import Placeholder from '../components/ui/Typography/Placeholder'

export default withTypography(Placeholder)
